import { render, staticRenderFns } from "./RegisterValidate.vue?vue&type=template&id=24d48411&scoped=true"
import script from "./RegisterValidate.vue?vue&type=script&lang=js"
export * from "./RegisterValidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d48411",
  null
  
)

export default component.exports